"use client";

import { ReactNode } from "react";
import NextForm from "next/form";
import { GridRowId } from "@mui/x-data-grid-pro";
import { useCampaignDialogs } from "../Providers/CampaignDialogsContext";
import { useDeleteDialog } from "../Providers/DeleteDialogContext";
import { deleteCampaignsAction } from "../actions";

interface FormProps {
  children: ReactNode;
}

export default function Form({ children }: FormProps) {
  const { setRowSelectionModel } = useCampaignDialogs();
  const { campaignIdsToDelete, closeDeleteDialog } = useDeleteDialog();

  const handleAction = async (formData: FormData) => {
    const result = await deleteCampaignsAction(formData);
    if (result.success) {
      closeDeleteDialog();
      setRowSelectionModel({
        ids: new Set<GridRowId>([]),
        type: "include",
      });
    } else {
      console.error("Error deleting campaigns:", result.error);
    }
  };

  return (
    <NextForm action={handleAction}>
      {campaignIdsToDelete.map((id) => (
        <input key={id} type="hidden" name="ids" value={id} />
      ))}
      {children}
    </NextForm>
  );
}
